export default "__VITE_ASSET__DcLO747I__"